module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second.542a28e2.svg";